<template>
  <div class="visited-tags__wrapper">
    <el-scrollbar
      v-show="history.length > 0"
      class="visited-tags__container"
      ref="scrollbar"
    >
      <div class="visited-tags__inner">
        <router-link
          v-for="tag in history"
          :key="tag.path"
          :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
          :class="['visited-tags', { active: tag.path === $route.path }]"
          tag="span"
          ref="tag"
          @contextmenu.prevent.native="openMenu(tag, $event)"
        >
          {{ tag.meta.title || tag.meta.name || tag.path }}
          <i
            class="el-icon-close close"
            @click.stop="closeTag(tag)"
          />
        </router-link>
      </div>
    </el-scrollbar>
    <ul
      v-show="visible"
      :style="{ top, left }"
      class="menu"
    >
      <li @click="closeTag(selectedTag)">关闭</li>
      <li @click="closeOtherTags">关闭其他</li>
      <li @click="closeAll">关闭全部</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'VisitedTags',

  watch: {
    '$route': {
      handler (value) {
        const index = this.history.findIndex(item => item.name === value.name)
        if (value.meta.hideTag) return
        if (index >= 0) {
          this.history.splice(index, 1, value)
        } else {
          this.history.push(value)
        }
        const tags = this.$refs.tag || []
        this.$nextTick(() => {
          for (let tag of tags) {
            if (tag.to.path === this.$route.path) {
              tag.$el.scrollIntoView()
              break
            }
          }
          const scrollbar = this.$refs.scrollbar
          scrollbar && scrollbar.update()
        })
      },
      immediate: true
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },

  data () {
    return {
      history: [],
      visible: false,
      selectedTag: null,
      top: 0,
      left: 0
    }
  },

  methods: {
    closeTag (tag) {
      const index = this.history.findIndex(item => item === tag)
      if (index === -1) return
      this.history.splice(index, 1)
      if (tag.path === this.$route.path) {
        const lastTag = this.history[this.history.length - 1]
        if (lastTag) {
          this.$router.replace({
            path: lastTag.path,
            query: lastTag.query,
            fullPath: lastTag.fullPath
          })
        }
      }
    },
    closeOtherTags () {
      this.history = this.history.filter(item => item === this.selectedTag)
    },
    closeAll () {
      this.history = []
    },
    openMenu (tag, event) {
      const menuMinWidth = 105
      if (!this.$el) return
      const { top: offsetTop, left: offsetLeft } = this.$el.getBoundingClientRect()
      const offsetWidth = this.$el.offsetWidth
      const maxLeft = offsetWidth - menuMinWidth
      const left = event.clientX - offsetLeft + 15
      if (left > maxLeft) {
        this.left = maxLeft + 'px'
      } else {
        this.left = left + 'px'
      }
      this.top = event.clientY - offsetTop + 30 + 'px'
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu () {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .visited-tags {
    display: inline-block;
    margin-right: 4px;
    margin-bottom: 5px;
    padding: 4px 6px;
    border-radius: 2px;
    border: 1px solid #eee;
    font-size: 12px;
    cursor: pointer;
    color: $--color-text-primary;
    background-color: #fff;
    .close {
      font-size: 12px;
      color: inherit;
      &:hover {
        color: mix($--color-text-primary, $--color-white, 80%);
      }
    }
    &.active {
      background-color: $--color-primary;
      color: $--color-white;
      .close:hover {
        color: mix($--color-text-primary, $--color-primary, 50%);
      }
    }
  }
  .visited-tags__container {
    min-height: 24px;
    width: 100%;
    /deep/ .el-scrollbar__wrap {
      overflow: auto;
      overflow-y: hidden;
      .el-scrollbar__view {
        white-space: nowrap;
      }
    }
  }
  .visited-tags__inner {
    margin-bottom: 10px;
  }
  .visited-tags__wrapper {
    // position: sticky;
    position: relative;
    padding: 7px 20px;
    background-color: #ecf0f5;
    color: #333;
  }
  .menu {
    position: absolute;
    padding: 5px 0;
    width: 105px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 2px 2px 5px 0 #333;
    z-index: 999;
    font-size: 12px;
    li {
      padding: 5px 10px;
      cursor: pointer;
      &:hover {
        background-color: #f0f0f0;
      }
    }
  }
</style>
